"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.specialLayerData_sys = exports.specialLayerData_hull = exports.specialLayerData_decor = exports.specialLayerData_floor = void 0;
var voyageTileData_1 = require("./voyageTileData");
exports.specialLayerData_floor = [
    {
        t: voyageTileData_1.EVoyageTile.SquareBottom,
    },
    {
        t: voyageTileData_1.EVoyageTile.FakeBottom,
    },
    {
        t: voyageTileData_1.EVoyageTile.Null2,
    },
    {
        t: voyageTileData_1.EVoyageTile.Floor,
    },
];
exports.specialLayerData_decor = [
    {
        t: voyageTileData_1.EVoyageTile.Null2,
    },
    {
        t: voyageTileData_1.EVoyageTile.Floor,
    },
    {
        t: voyageTileData_1.EVoyageTile.Door,
        s: 0,
        c: 2,
    },
    {
        t: voyageTileData_1.EVoyageTile.Door,
        s: 1,
        c: 2,
    },
    {
        t: voyageTileData_1.EVoyageTile.Table,
    },
    {
        t: voyageTileData_1.EVoyageTile.Chair,
    },
    {
        t: voyageTileData_1.EVoyageTile.Fence,
        s: 0,
        c: 2,
    },
    {
        t: voyageTileData_1.EVoyageTile.Fence,
        s: 1,
        c: 2,
    },
    {
        t: voyageTileData_1.EVoyageTile.Fence,
        s: 2,
        c: 2,
    },
    {
        t: voyageTileData_1.EVoyageTile.Fence,
        s: 3,
        c: 2,
    },
    {
        t: voyageTileData_1.EVoyageTile.Fence,
        s: 5,
        c: 2,
    },
    {
        t: voyageTileData_1.EVoyageTile.Fence,
        s: 4,
        c: 2,
    },
];
exports.specialLayerData_hull = [
    {
        t: voyageTileData_1.EVoyageTile.Null2,
    },
    {
        t: voyageTileData_1.EVoyageTile.Floor,
    },
    {
        t: voyageTileData_1.EVoyageTile.Square,
        c: 1,
    },
    {
        t: voyageTileData_1.EVoyageTile.Triangle,
        s: 0,
        c: 2,
    },
    {
        t: voyageTileData_1.EVoyageTile.Triangle,
        s: 1,
        c: 2,
    },
    {
        t: voyageTileData_1.EVoyageTile.Triangle,
        s: 2,
        c: 2,
    },
    {
        t: voyageTileData_1.EVoyageTile.Triangle,
        s: 3,
        c: 2,
    },
];
exports.specialLayerData_sys = [
    {
        t: voyageTileData_1.EVoyageTile.Null3,
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'bed',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'rack-empty',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'rack-br',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'rack-ext',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'rack-wr',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'rack-suit',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'rack-mop',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'rack-med',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'rack-torp',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'torpedo-',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'loader-',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'laser-',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'fp-',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'coffee',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'hyper',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'coms',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'sensor-internal',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'sensor-external',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'nav',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'captain',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'cargo',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'tele',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'ejector-',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'ejectrol-',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'ejp-',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'med-',
    },
    {
        t: voyageTileData_1.EVoyageTile.MedPad,
        text: 'pad-',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'life-support',
    },
    {
        t: voyageTileData_1.EVoyageTile.System,
        text: 'reactor',
    },
];
